import "./orderHistoryItem.css";

import reOrder from "../../../../assests/icons/rotate-left.svg";

import { Link } from "react-router-dom";
import { ADD_TO_CART, fetchRegisterId } from "../../../../Constants";


const OrderHistoryItem = ({ historyDeatils, setOrderID_details }) => {
  var elementColor;
  var value = historyDeatils.OrderStatus;

  //console.log(value);
  if (value === "cancelled") {
    elementColor = "itemStatus cancelled";
  } else if (value === "pending") {
    elementColor = "itemStatus pending";
  } else {
    elementColor = "itemStatus completed";
  }
  const addToCart = async (productId) => {

    try {
 
      let RegisterId = fetchRegisterId()
     

     

      if(RegisterId){
        
              const response = await fetch(ADD_TO_CART, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  ProductId: productId,
                  RegisterId,
                  ProductQuantity: 1, // Adjust as needed, depending on how quantity is managed
                }),
              });

              if (!response.ok) {
                throw new Error(
                  `Failed to add product to cart! Status: ${response.status}`
                );
              }
      }




      // toast.success("Product successfully added to cart!");
    } catch (error) {
      console.error("Error adding product to cart:", error);
      //   toast.error("Error adding product to cart");
    }
  };

  const handleReorder = (id) => {
    addToCart(id)
  };

  return (
    <div className="historyItemWrapper">
      <div className="orderIdWrapper">
        <div className="idDetails">
          <div className="orderIdName"> Order Id </div>
          <div className="idText "> #{historyDeatils.OrderId}</div>
        </div>
        <div className={elementColor} id="itemStatus">
          {historyDeatils.OrderStatus.charAt(0).toUpperCase() +
            historyDeatils.OrderStatus.slice(1).replace(/_/g, ' ')}
        </div>
      </div>
      {historyDeatils.Products &&
        historyDeatils.Products.map((product,index) => (
          <div className="orderDetailsWrapper" key={product.id || index}>
            <div className="detailBox">
              <div className="detailsContent">
                <Link
                  to={`/order-status/order?id=${historyDeatils.OrderId}`}
                  className="linkDetails"
                  onClick={() => setOrderID_details(historyDeatils)}
                >
                  <div className="history__item__image">
                    <img
                      src={product.CoverImage}
                      alt="No Image"
                      className="imgShow"
                       loading="lazy"
                    />
                  </div>

                  <div className="orderDetails">
                    <div className="history__item__title">{product.Title}</div>
                    <div className="actual_price">₹{ product.ProductQuantity? product.Price/product.ProductQuantity : product.Price}</div>
                    <div className="orderedDate">{product.Date}</div>
                    <div className="orderedDate">Quantity : {product.ProductQuantity}</div>
                  </div>
                </Link>

                <Link className="reOrderWrapper" to={"/cart"}>
                  <button
                    className="StartShopping__btn btn_primary"
                    onClick={() => handleReorder(product.ProductId)}
                  >
                    {" "}
                    <img src={reOrder} className="location__icon" loading="lazy" />
                    Re-Order
                  </button>
                </Link>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
export default OrderHistoryItem;
